export default __webpack_public_path__ + "static/media/pet-visit-panel-icon.0f2297ab.svg";